import * as fromStore from './store';
import { LoggingService } from '../services/logging/logging.service';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    constructor(protected rootStore: Store<fromStore.LoadingState>) {}

    public Load(): void {
        this.rootStore.dispatch(new fromStore.SetLoading(true));
    }

    public Stop(): void {
        this.rootStore.dispatch(new fromStore.SetLoading(false));
    }
}
